<template>
	<div class="award">
		<div class="award__table award__list">
			<table class="simple-table">
				<thead>
					<tr>
						<th class="award__list__num">항번</th>
						<th class="award__list__name">제품명</th>
						<th class="award__list__sort">순위라벨</th>
						<th class="award__list__btn">평점</th>
						<th class="award__list__btn">리뷰건수</th>
						<th class="award__list__categoryNum">리뷰시작일</th>
						<th class="award__list__btn">리뷰종료일</th>
						<th class="award__list__btn">수정</th>
						<th class="award__list__btn">삭제</th>
					</tr>
				</thead>
				<tbody v-if="formatMappingProduct">
					<tr
						v-for="(item, idx) in formatMappingProduct"
						:key="item.idProduct"
					>
						<td class="award__list__num">
							{{ item.idProduct }}
						</td>
						<td class="award__list__name">
							<span class="award__list__brand"
								>[{{ item.brandTitle }}]</span
							>
							{{ item.productTitle }}
						</td>
						<td class="award__list__sort">
							<input
								v-model="item.rankLabel"
								@input="getSortKey(idx, $event)"
								type="text"
							/>
						</td>
						<td class="award__list__num">
							{{ item.ratingAvg }}
						</td>
						<td class="award__list__num">
							{{ item.reviewCount }}
						</td>
						<td class="award__list__categoryNum">
							{{ item.startDate }}
						</td>
						<td class="award__list__categoryNum">
							{{ item.endDate }}
						</td>
						<td class="award__list__btn">
							<button
								@click="modifyMapping(idx)"
								class="btn orange"
							>
								수정
							</button>
						</td>
						<td class="award__list__btn">
							<button
								@click="deleteMapping(idx)"
								class="btn gray"
							>
								삭제
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>
<script>
	import { mapGetters } from 'vuex';

	export default {
		name: 'AwardProductMapping',
		data() {
			return {
				categorySortList: [],
				categoryProductList: [],
			};
		},
		computed: {
			...mapGetters('award', ['formatMappingProduct']),
		},
		watch: {
			formatMappingProduct() {
				this.formatMappingProduct &&
					this.formatMappingProduct.forEach((item, idx) => {
						this.categorySortList[idx] = item.rankLabel;
						this.categoryProductList[idx] = item.idProduct;
					});
			},
		},
		methods: {
			getSortKey: _.debounce(async function (index, event) {
				this.categorySortList[index] = event.target.value;
			}, 500),

			async modifyMapping(index) {
				if (!confirm('정말 수정하시겠습니까?')) return;
				try {
					const { idHitCategory } = this.$route.query;
					const params = {
						rankLabel: this.categorySortList[index],
					};
					const idProduct = this.categoryProductList[index];
					await this.$axiosAdmin2.put(
						`/api/award/thirdcategory/${idProduct}/${idHitCategory}/product-mappings`,
						params
					);
					alert('수정되었습니다.');
					this.getList();
				} catch (err) {
					console.error(err);
				}
			},
			async deleteMapping(index) {
				if (!confirm('정말 삭제하시겠습니까?')) return;
				try {
					const { idHitCategory } = this.$route.query;
					const idProduct = this.categoryProductList[index];
					await this.$axiosAdmin2.delete(
						`/api/award/thirdcategory/${idProduct}/${idHitCategory}/product-mappings`
					);
					alert('삭제되었습니다.');
					this.getList();
				} catch (err) {
					console.error(err);
				}
			},
			async getList() {
				const { idHitProduct, idHitCategory } = this.$route.query;
				await this.$store.dispatch('award/getMappinCategory', {
					idHitProduct,
					idHitCategory,
				});
			},
		},
	};
</script>
<style lang="scss" scoped>
	.award {
		&__table {
			margin-top: 20px;
			.simple-table {
				th {
					text-align: center;
					padding: 0;
				}
			}
		}

		&__list {
			margin-top: 70px;

			&__btn {
				width: 30px;
				text-align: center;
				button {
					&:disabled {
						border: none;
					}
				}
			}
			&__brand {
				color: $font-blue;
			}
			&__num {
				width: 30px;
				text-align: center;
			}
			&__name {
				width: 300px;
			}
			&__sort {
				width: 70px;
			}
			&__categoryNum {
				width: 100px;
				text-align: center;
			}
		}
	}
</style>
